// ** React Imports
import React from 'react'

// ** Child Imports
import AnalyticsDataWidget from '../visualizations/AnalyticsDataWidget'

// ** Types Imports
import { WidgetType } from 'src/lib/types/dashboardAnalytics'

// ** Util Imports
import { initialOrdersWidgetData, ordersWidgetsConfig } from 'src/assets/AnalyticsConfig'
import { analyticsConstants } from 'src/lib/utils/constants'

const OrderDataWidget: React.FC<WidgetType> = ({ value, isLoading, id, hasComparison, moreIsGood }) => {
  const getCurrentWidgetIndex = () => {
    switch (id) {
      case analyticsConstants.FLO_ORDERS_COUNT:
        return hasComparison ? 3 : 0
      case analyticsConstants.FLO_ORDERS_SALES:
        return hasComparison ? 4 : 1
      case analyticsConstants.FLO_ORDERS:
        return hasComparison ? 5 : 2
      default:
        return hasComparison ? 3 : 0
    }
  }

  const currentValue = value ?? initialOrdersWidgetData?.data?.widgetData
  const currentIndex = getCurrentWidgetIndex()

  const fontProperties = {
    fontSize: 28,
    fontWeight: 600,
    fontColor: '#4D4D4D',
    lineHeight: '36px'
  }

  const compareToFontProperties = {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '20px'
  }

  const subDetailsFontProperties = {
    fontSize: 16,
    fontWeight: 600,
    fontColor: '#4D4D4D',
    lineHeight: '20px'
  }

  const compareToFontPropertiesForSubDetails = {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '14px'
  }

  const getMainValue = () => {
    switch (id) {
      case analyticsConstants.FLO_ORDERS:
        return currentValue?.[hasComparison ? 5 : 2]?.x
      default:
        return currentValue?.[hasComparison ? 7 : 3]?.x
    }
  }

  const getCompareToMainValue = () => {
    switch (id) {
      case analyticsConstants.FLO_ORDERS:
        return currentValue?.[2]?.compare_to_x
      default:
        return currentValue?.[3]?.compare_to_x
    }
  }

  return (
    <div className='flex flex-col gap-3'>
      <AnalyticsDataWidget
        hideBorders
        widgetType={ordersWidgetsConfig?.[currentIndex]?.widgetType}
        valueType={ordersWidgetsConfig?.[currentIndex]?.valueType}
        widgetWidth={'100%'}
        widgetHeight={50}
        fontProperties={fontProperties}
        value={getMainValue() ?? '0'}
        {...(hasComparison ? { compareToValue: getCompareToMainValue() ?? '0' } : {})}
        isLoading={isLoading}
        removeInnerPadding
        cardVariant='outlined'
        moreIsGood={moreIsGood}
        description={ordersWidgetsConfig?.[currentIndex]?.description}
        compareToFontProperties={compareToFontProperties}
      />
      <div className='grid grid-cols-2 gap-2'>
        {ordersWidgetsConfig?.[currentIndex]?.subDetails?.map((detail: WidgetType, index: number) => {
          return (
            <AnalyticsDataWidget
              key={`${index}`}
              hideBorders
              widgetType={detail?.widgetType}
              valueType={detail?.valueType}
              widgetWidth={'100%'}
              widgetHeight={50}
              description={detail?.description}
              fontProperties={subDetailsFontProperties}
              value={currentValue?.[hasComparison ? 4 + index : index]?.x ?? '0'}
              {...(hasComparison ? { compareToValue: currentValue?.[index]?.compare_to_x ?? '0' } : {})}
              isLoading={isLoading}
              removeInnerPadding
              cardVariant='outlined'
              moreIsGood={moreIsGood}
              compareToFontProperties={compareToFontPropertiesForSubDetails}
            />
          )
        })}
      </div>
    </div>
  )
}

export default OrderDataWidget
